export const tldList: Array<string> = ['com', 'net', 'org', 'edu'];
